var map = {
	"./skin1/searchTipTitle.png": "9910",
	"./skin2/searchTipTitle.png": "5bd0",
	"./skin3/searchTipTitle.png": "7bca",
	"./skin4/searchTipTitle.png": "e8aa",
	"./skin5/searchTipTitle.png": "b010",
	"./skin6/searchTipTitle.png": "8ce1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "01dd";